import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import api, { fileUrl } from "@/lib/api";

export default function BlogPage() {
  const [posts, setPosts] = useState(null);
  const [tag, setTag] = useState("");
  const [q, setQ] = useState("");

  const load = (params = {}) => {
    api.get("/blog", { params }).then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  };

  useEffect(() => {
    load(tag ? { tag } : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag]);

  const allTags = [...new Set((posts || []).flatMap((p) => p.tags || []))];

  return (
    <div data-testid="blog-page" className="max-w-7xl mx-auto px-4 sm:px-8 mt-10">
      <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">Hello Nanba Blog</h1>
      <p className="text-slate-500 mt-2">Updates, offers, seller stories and marketplace news.</p>

      <div className="flex items-center gap-4 mt-8 flex-wrap">
        <form onSubmit={(e) => { e.preventDefault(); load({ ...(tag ? { tag } : {}), ...(q ? { q } : {}) }); }} className="flex">
          <input data-testid="blog-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search posts, tags, keywords…"
            className="h-10 w-64 rounded-l-full border border-r-0 border-slate-200 px-4 text-sm outline-none focus:border-blue-500" />
          <button data-testid="blog-search-btn" className="h-10 px-4 rounded-r-full bg-slate-900 text-white"><Search className="w-4 h-4" /></button>
        </form>
        <div className="flex gap-2 flex-wrap">
          <button data-testid="blog-tag-all" onClick={() => setTag("")}
            className={`text-xs px-3.5 py-1.5 rounded-full border transition-colors ${!tag ? "bg-slate-900 text-white border-slate-900" : "border-slate-200 text-slate-600"}`}>All</button>
          {allTags.map((t) => (
            <button key={t} data-testid={`blog-tag-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} onClick={() => setTag(tag === t ? "" : t)}
              className={`text-xs px-3.5 py-1.5 rounded-full border transition-colors ${tag === t ? "bg-slate-900 text-white border-slate-900" : "border-slate-200 text-slate-600 hover:border-slate-400"}`}>
              {t}
            </button>
          ))}
        </div>
      </div>

      {!posts ? (
        <div className="h-64 mt-8 rounded-2xl bg-slate-100 animate-pulse" />
      ) : !posts.length ? (
        <div data-testid="blog-empty" className="mt-10 rounded-2xl bg-slate-50 py-20 text-center">
          <p className="font-heading text-xl font-bold">No posts yet</p>
          <p className="text-sm text-slate-500 mt-2">Check back soon for updates.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-3 gap-8 mt-10">
          {posts.map((p, i) => (
            <Link key={p.id} to={`/blog/${p.id}`} data-testid={`blog-card-${p.id}`}
              className="product-card group block stagger-item" style={{ animationDelay: `${i * 60}ms` }}>
              {p.cover_image && (
                <div className="rounded-xl overflow-hidden aspect-[16/9] bg-slate-100">
                  <img src={fileUrl(p.cover_image)} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
              )}
              <div className="pt-4">
                <div className="flex gap-1.5 flex-wrap">
                  {(p.tags || []).map((t) => <span key={t} className="text-[10px] uppercase tracking-widest font-bold text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full">{t}</span>)}
                </div>
                <h2 className="font-heading text-lg font-bold mt-2 leading-snug group-hover:text-blue-600 transition-colors">{p.title}</h2>
                <p className="text-sm text-slate-500 mt-2 line-clamp-2">{p.body}</p>
                <p className="text-xs text-slate-400 mt-3">{p.author} · {new Date(p.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
